module.exports = __webpack_public_path__ + "static/img/brees-2016-top-image.f80fb54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-top-image.jpg
// module id = KZxz
// module chunks = 1